import { useRef } from "react";
import Badge from "../../components/Badge";
import Box from "../../components/Box";
import { useAppSelector } from "../../hooks/reduxHooks";

const ProductDetails = ({
  customizeTableData,
  handleChangeTitle,
  handleChangeDescription,
  tags,
  setTags,
  collections,
  setCollections,
}: any) => {
  const tagRef = useRef<any>();
  const collectionRef = useRef<any>();

  const designImageURL = useAppSelector(
    (state: any) => state.canvases.designImageURL
  );

  const availableTags = tags;
  const availableCollections = collections;

  const deleteTag = (tag: string) => {
    setTags((prev: any) => prev.filter((item: any) => item !== tag));
  };

  const addTag = (e: any) => {
    e.preventDefault();
    if (tagRef.current.value && !tags.includes(tagRef.current.value)) {
      setTags((prev: any) => [...prev, tagRef.current.value]);
    }
  };

  const handleTag = (e: any) => {
    if (e.target.value && !tags.includes(e.target.value)) {
      setTags((prev: any) => [...prev, e.target.value]);
    }
  };

  const deleteCollection = (tag: string) => {
    setCollections((prev: any) => prev.filter((item: any) => item !== tag));
  };

  const addCollection = (e: any) => {
    e.preventDefault();
    if (
      collectionRef.current.value &&
      !collections.includes(collectionRef.current.value)
    ) {
      setCollections((prev: any) => [...prev, collectionRef.current.value]);
    }
  };

  const handleCollection = (e: any) => {
    if (e.target.value && !tags.includes(e.target.value)) {
      setCollections((prev: any) => [...prev, e.target.value]);
    }
  };

  return (
    <Box>
      <div className="flex max-md:flex-col items-stretch justify-between gap-5">
        <div className="w-full max-w-[350px] pr-5 border-r max-md:border-r-0 max-md:border-b pb-3 border-solid border-gray-200">
          <h3>Product details</h3>
          <br />
          <p>
            Give your product some information to let the world know why they
            will love it so much!
          </p>
        </div>
        <div className="w-full">
          <div className="mb-5">
            <img
              src={
                designImageURL
                  ? designImageURL
                  : customizeTableData.productImage
              }
              alt=""
              width={300}
            />
          </div>
          <div className="mb-5">
            <label
              className="block font-bold text-gray-600 mb-1"
              htmlFor="title"
            >
              Title:
            </label>
            <input
              className="block w-full max-w-[364px] px-4 py-2 bg-gray-50 focus:bg-white rounded-md border border-gray-300"
              type="text"
              id="title"
              defaultValue={customizeTableData.title}
              onChange={(e) => handleChangeTitle(e)}
            />
            <p className="text-gray-500 text-xs">
              The higher the DPI the higher the resolution
            </p>
          </div>

          <div className="mb-5">
            <div className="block font-bold text-gray-600 mb-1">
              Customization Method:
            </div>
            <div>
              <Badge blue>Engraved</Badge>
            </div>
          </div>

          <div className="mb-5">
            <label
              className="block font-bold text-gray-600 mb-1"
              htmlFor="desc"
            >
              Description:
            </label>
            <textarea
              className="block w-full max-w-[730px] h-[250px] px-4 py-2 rounded-lg border border-gray-300 bg-gray-50 focus:bg-white"
              name="desc"
              id="desc"
              value={customizeTableData.body_html}
              onChange={handleChangeDescription}
            ></textarea>
          </div>

          <div className="mb-5">
            <label
              className="block font-bold text-gray-600 mb-1"
              htmlFor="tags"
            >
              Product Tags:
            </label>
            <div className="relative">
              <select
                className="block w-full max-w-[364px] p-2 mb-2 bg-gray-50 focus:bg-white rounded-md border border-gray-300"
                name="tag"
                onChange={handleTag}
              >
                {availableTags.map((item: any, index: number) => (
                  <option value={item} key={index}>
                    {item}
                  </option>
                ))}
              </select>
              <form
                onSubmit={addTag}
                className="absolute left-1 top-[5px] bg-red"
              >
                <input
                  type="text"
                  placeholder="Add Product Tags"
                  className="block w-full max-w-[364px] px-2 py-2 bg-gray-50 focus:bg-white rounded-md h-6 w-60 cursor-pointer"
                  ref={tagRef}
                />
              </form>
            </div>
            <div>
              {tags.map((item: any, index: number) => (
                <Badge blue key={index}>
                  {item}{" "}
                  <button
                    className="text-[11px] mt-[1px]"
                    onClick={() => deleteTag(item)}
                  >
                    X
                  </button>
                </Badge>
              ))}
            </div>
          </div>

          {/* <div className="mb-5">
            <label
              className="block font-bold text-gray-600 mb-1"
              htmlFor="collect"
            >
              Product Collections:
            </label>
            <div className="relative">
              <select
                className="block w-full max-w-[364px] p-2 mb-2 bg-gray-50 focus:bg-white rounded-md border border-gray-300"
                name="collect"
                onChange={handleCollection}
              >
                {availableCollections.map((item: any, index: number) => (
                  <option value={item} key={index}>
                    {item}
                  </option>
                ))}
              </select>
              <form
                onSubmit={addCollection}
                className="absolute left-1 top-[5px] bg-red"
              >
                <input
                  ref={collectionRef}
                  type="text"
                  className="block w-full max-w-[364px] px-2 py-2 bg-gray-50 focus:bg-white rounded-md h-6 w-60 cursor-pointer"
                  placeholder="Add Product Collections"
                />
              </form>
            </div>
            <div>
              {collections.map((item: any, index: any) => (
                <Badge blue key={index}>
                  {item}{" "}
                  <button
                    className="text-[11px] mt-[1px]"
                    onClick={() => deleteCollection(item)}
                  >
                    X
                  </button>
                </Badge>
              ))}
            </div>
          </div> */}
        </div>
      </div>
    </Box>
  );
};

export default ProductDetails;
